<template>
  <div
    v-if="showBackToTop" 
    :class="bem()" 
    @click="scrollToTop">
    <img src="../assets/images/back.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'back-to-top',
  data() {
    return {
      showBackToTop: false,
      twoScreenHeight: 0,
    };
  },
  methods: {
    // 滚动事件处理
    handleScroll() {
      this.showBackToTop = window.scrollY > window.innerHeight;
    },
    // 返回顶部方法
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    // 检查内容高度是否超过两屏
    checkContentHeight() {
      this.twoScreenHeight = window.innerHeight * 2;
      if (document.documentElement.scrollHeight > this.twoScreenHeight) {
        this.showBackToTop = true;
      }
    },
  },
  mounted() {
    // 初始化检查内容高度
    this.checkContentHeight();
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  img {
    width: 84px;
    height: 84px;
    user-select: none;
    -webkit-user-drag: none;
  }
}
</style>
